import { Award } from "lucide-react";
import { RECOGNITIONS } from "../mock";

/**
 * Clean, framed-less Restaurantji recognition badge — just the green award icon
 * with a small caption. Links to the restaurant's Restaurantji profile.
 */
export default function RestaurantjiBadge({ variant = "footer", className = "" }) {
  const rec = RECOGNITIONS[0];
  if (!rec) return null;

  const iconSize = variant === "footer" ? "w-9 h-9" : "w-12 h-12";
  const iconGlyph = variant === "footer" ? "w-4 h-4" : "w-6 h-6";

  return (
    <a
      href={rec.url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={rec.alt}
      data-testid="restaurantji-badge"
      className={`inline-flex items-center gap-3 group hover:opacity-90 transition-opacity ${className}`}
    >
      <span
        className={`inline-flex items-center justify-center ${iconSize} rounded-full shrink-0 ${
          variant === "footer"
            ? "bg-brand-light/15 text-brand-light ring-1 ring-brand-light/30"
            : "bg-brand/10 text-brand ring-1 ring-brand/25 shadow-md"
        } group-hover:scale-105 transition-transform`}
      >
        <Award className={iconGlyph} strokeWidth={2} />
      </span>
      <span className="flex flex-col leading-tight">
        <span className={`font-display font-semibold ${variant === "footer" ? "text-[13px] text-cream" : "text-[15px] text-granite-dark"}`}>
          {rec.label} {rec.year}
        </span>
        <span className={`text-[10px] uppercase tracking-[0.12em] mt-0.5 ${variant === "footer" ? "text-cream/55" : "text-granite/60"}`}>
          Awarded on Restaurantji →
        </span>
      </span>
    </a>
  );
}
